const imageCopyrightSelector = "[data-image-copyright]";
const toggleSelector = "[data-image-copyright-toggle]";
const closeSelector = "[data-image-copyright-close]";

function setImageCopyrightState(element, isOpen) {
    const toggle = element.querySelector(toggleSelector);
    const close = element.querySelector(closeSelector);

    element.dataset.copyrightOpen = isOpen.toString();
    element.classList.toggle("max-w-6", !isOpen);
    element.classList.toggle("max-w-fit", isOpen);

    if (toggle) {
        toggle.setAttribute("aria-expanded", isOpen.toString());
    }

    if (close) {
        close.hidden = !isOpen;
    }
}

function closeImageCopyright(element, restoreFocus = false, blurFocus = false) {
    const toggle = element.querySelector(toggleSelector);
    const activeElement = document.activeElement;

    setImageCopyrightState(element, false);

    if (restoreFocus && toggle) {
        toggle.focus();
        return;
    }

    if (
        blurFocus &&
        element.contains(activeElement) &&
        typeof activeElement.blur === "function"
    ) {
        activeElement.blur();
    }
}

function initImageCopyright() {
    const items = Array.from(document.querySelectorAll(imageCopyrightSelector));

    if (!items.length) {
        return;
    }

    items.forEach((item) => {
        const toggle = item.querySelector(toggleSelector);
        const close = item.querySelector(closeSelector);

        setImageCopyrightState(item, false);

        toggle?.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            const isOpen = item.dataset.copyrightOpen === "true";

            items.forEach((otherItem) => {
                if (otherItem !== item) {
                    closeImageCopyright(otherItem);
                }
            });

            if (isOpen) {
                closeImageCopyright(item, false, event.detail > 0);
                return;
            }

            setImageCopyrightState(item, true);
        });

        close?.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            closeImageCopyright(item, event.detail === 0, event.detail > 0);
        });
    });

    document.addEventListener("click", (event) => {
        items.forEach((item) => {
            if (item.dataset.copyrightOpen !== "true") {
                return;
            }

            if (!item.contains(event.target)) {
                closeImageCopyright(item, false, true);
            }
        });
    });

    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }

        items.forEach((item) => {
            if (item.dataset.copyrightOpen !== "true") {
                return;
            }

            closeImageCopyright(item, item.contains(document.activeElement));
        });
    });
}

export { initImageCopyright };
